export const gatherTypeMap = {
  FILL: "已填写",
  NOT_FILL: "未填写",
  SUM: "求和",
  AVG: "平均值",
  MAX: "最大值",
  MIN: "最小值"
}

export const systemFields = [
  { cid: "cid", value: "creator", label: "创建人", name: "创建人", type: "staff" },
  { cid: "cat", value: "createAt", label: "创建时间", name: "创建时间", type: "time" },
  {
    cid: "upid",
    value: "updateUser",
    label: "最后修改人",
    name: "最后修改人",
    type: "staff"
  },
  { cid: "uat", value: "updateAt", label: "最后修改时间", name: "最后修改时间", type: "time" },
  { cid: "oid", value: "owner", label: "负责人", name: "负责人", type: "staff" }
]
